import styled from '@emotion/styled';

const BORDER_WIDTH = '1px';

export const ToggleContainer = styled.div<{ disabled: boolean; selected: boolean }>`
  /* background-color: yellow; */
  position: relative;
  display: flex;
  width: 40px;
  height: 20px;
  border-radius: 20px;
  flex-shrink: 0;
  z-index: 1;

  /* transition: border 1000ms; */

  --backgroundColor: ${(props) =>
    props.selected ? (props) => props.theme.colors.pillColor : (props) => props.theme.colors.backgroundColor};

  --borderColor: ${(props) =>
    props.disabled || !props.selected ? "#cecece" : (props) => props.theme.colors.pillColor};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border: ${BORDER_WIDTH} solid var(--borderColor);
`;

export const Knob = styled.div`
  position: relative;
  top: calc(-${BORDER_WIDTH} );
  left: calc(-${BORDER_WIDTH});
  width: 20px;
  height: 20px;
  border-radius: inherit;
  border: inherit;
  background-color: #fff;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: inherit;
  background-color: var(--backgroundColor);
`;
